import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import info from "../../../../assets/icons/info-circle-white.svg";
import radioButton from "../../../../assets/icons/Radiobuttons.png";
import check from "../../../../assets/icons/white-check.png";
import Close from "../../../../assets/icons/x-close-red.svg";
import BudgetOptimization from "../../../../assets/images/BudgetOptimization.png";
import Data from "../../../../assets/images/data.png";
import DataSharing from "../../../../assets/images/DataSharing.png";
import DirectSale from "../../../../assets/images/directSale.png";
import DirectSale1 from "../../../../assets/images/DirectSales.png";
import disabledCheck from "../../../../assets/images/disabledCheck.png";
import EnhancedInventory from "../../../../assets/images/Enhancedinventory.png";
import ExBoImage from "../../../../assets/images/ExBOimageImpression.png";
import ExConfirmSale from "../../../../assets/images/ExConfirmedSale.png";
import ExConversion from "../../../../assets/images/ExConversion.png";
import ExPurpose from "../../../../assets/images/ExPurpose.png";
import ExThreshold from "../../../../assets/images/ExThreshold.png";
import OptimizedProduction from "../../../../assets/images/optimizeProduct.png";
import ProactiveReordering from "../../../../assets/images/proActiveReOrdering.png";
import SupplyChain from "../../../../assets/images/supplyChain.png";
import Sustainability from "../../../../assets/images/Sustainability.png";
import WasteDirective from "../../../../assets/images/wasteDirective.png";
import * as Library from "../../../../utils/Library";
import CardComponentContainer from "../../../common/cardContainers/CardComponentContainer";
import DialogBoxComponent from "../../../common/dialogs/DialogBoxComponent";
import FormField from "../../../common/forms/FormField";
import FullScreenOverlay from "../../../common/overlay/FullScreenOverlay";
import StandardStockPopup from "../../../common/standardStockPopup/StandardStockPopup";
import CheckboxVector from "../../../common/checkbox/CheckboxVector";

// #region SCOPED CSS
const StyledPage = styled.div`
    &.frame-194,
    &.frame-194 * {
        box-sizing: border-box;
    }
    &.frame-194 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .stock-sharing-container .disabled-texts span {
        color: var(--text-icons-gray-300, #4f5b6d);
        cursor: not-allowed;
    }

    .frame-1942 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-189 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .dropdown-selector {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 393px;
        position: relative;
    }
    .frame-1000011201 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .btn-large-solid-inverted-01 {
        flex-shrink: 0;
        width: 150px;
        position: relative;
    }
    .disabled {
        color: #d1d1d1 !important;
        opacity: 0.5;
        pointer-events: none;
    }
    .simple {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 101px;
        position: relative;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 88px;
        position: relative;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 4px;
        padding: 10px 12px 10px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 98px;
        position: relative;
    }
    .you-can-always-change-this-decision-on-a-store-by-store-level-in-the-store-lists-views-store-menu-in-the-navigation-bar-on-the-left-then-stores-button-in-the-control-bar-on-top-and-then-view-button-also-in-the-control-bar-on-the-right {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 11px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .last-container {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-bottom: 12px;
    }
    .CardBox-container {
        width: 450px !important;
    }
`;

const StockSharingStyles = styled.div`
    .frame-1000011201,
    .frame-1000011201 * {
        box-sizing: border-box;
    }
    .frame-1000011201 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011421 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        width: 529.33px;
        position: relative;
    }
    .frame-1000011450 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011410 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .do-you-want-to-share-stock-with-your-suppliers {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .tier-0 {
        background:
            linear-gradient(21.32deg, rgba(255, 153, 0, 0) 60%, rgba(255, 153, 0, 0.2) 100%),
            linear-gradient(to left, #141922, #141922);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        flex: 1;
        width: 529.33px;
        position: relative;
        overflow: hidden;
    }
    .line-3 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-1000011223 {
        padding: 14px 24px 14px 24px;
        display: flex;
        flex-direction: column;
        gap: 42px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011440 {
        display: flex;
        flex-direction: column;
        gap: 33px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .why-should-i-share-stock-with-my-suppliers {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Medium", sans-serif;
        font-size: 14px;
        letter-spacing: 0.015em;
        font-weight: 500;
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-1000011411 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 34px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000114322 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011434 {
        flex-shrink: 0;
        width: 69px;
        height: 69px;
        position: relative;
    }
    .group-1000011038 {
        width: 100%;
        position: absolute;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .text {
        color: #d1d1d1;
        text-align: left;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .text2 {
        color: #d1d1d1;
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011429 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011037 {
        width: 100%;
        position: absolute;
        overflow: visible;
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011428 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011040 {
        position: absolute;
        inset: 0;
    }
    .frame-1000011433 {
        width: 69px;
        height: 69px;
        position: absolute;
    }
    .group-1000011039 {
        height: 100%;
        position: absolute;
        left: -8px;
        top: 0px;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011427 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-large-inverted {
        background: #10141b;
        border-radius: 4px;
        padding: 18px 14px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 35px;
        position: relative;
        //top: 50px;
        cursor: pointer;
    }
    .button {
        color: #c2c8d1;
        text-align: center;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
    .frame-1000011406 {
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 16px;
        position: relative;
    }
    .radiobuttons {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
    }
    .rectangle-1 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 20px;
        border-style: solid;
        border-color: var(--text-and-icons-gray-200, #7c868b);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
        cursor: pointer;
    }
    .check {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
        cursor: pointer;
    }
    .frame-1000011217 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011407 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .i-don-t-want-to-share-my-stock-data-with-any-of-my-suppliers {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011251 {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .do-you-want-to-share-stock-with-your-suppliers2 {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        opacity: 0;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011449 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011414 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .tier-3 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 5px;
        border-style: solid;
        border-color: #3c485a;
        border-width: 1px;
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-1000011219 {
        padding: 40px 24px 60px 24px;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000114062 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .check2 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
        cursor: pointer;
    }
    .yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers {
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .frame-1000011439 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011409 {
        padding: 0px 0px 0px 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 64px;
        position: relative;
    }
    .frame-1000011221 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        white-space: nowrap;
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span4 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-1000011222 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .x-close2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-10000112172 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        white-space: nowrap;
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span4 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-1000011418 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 5px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 381px;
        position: relative;
    }
    .frame-1000011405 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000112232 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .even-if-you-allow-stock-sharing-your-stock-will-only-be-shared-with-brands-complying-with-the-below-supplier-conditions {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-1000011415 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .each-brand-can-only-see-stock-of-their-labeled-products {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-10000114212 {
        padding: 0px 0px 0px 24px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .supplier-conditions {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Medium", sans-serif;
        font-size: 12px;
        letter-spacing: 0.0125em;
        font-weight: 500;
        text-transform: uppercase;
        position: relative;
    }
    .line-5 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
    }
    .frame-1000011226 {
        padding: 48px 24px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000114092 {
        padding: 0px 0px 0px 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .check3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .the-brand-has-at-least-10-active-b-oimages {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .the-brand-has-at-least-10-active-b-oimages-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .the-brand-has-at-least-10-active-b-oimages-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .the-brand-has-at-least-10-active-b-oimages-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-1000011220 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .check4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .b-oimages-have-an-average-of-3-tagged-items {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .b-oimages-have-an-average-of-3-tagged-items-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .b-oimages-have-an-average-of-3-tagged-items-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .b-oimages-have-an-average-of-3-tagged-items-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .check5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .create-3-new-b-oimages-per-month {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .create-3-new-b-oimages-per-month-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .create-3-new-b-oimages-per-month-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .create-3-new-b-oimages-per-month-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-1000011425 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011422 {
        padding: 0px 0px 0px 24px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .extra-condition {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Medium", sans-serif;
        font-size: 12px;
        letter-spacing: 0.0125em;
        font-weight: 500;
        text-transform: uppercase;
        position: relative;
    }
    .frame-1000011224 {
        padding: 0px 24px 0px 56px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 91.5px;
        position: relative;
    }
    .check6 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .free-from-extra-conditions {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .info-circle {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .tier-2 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 5px;
        border-style: solid;
        border-color: #3c485a;
        border-width: 1px;
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-1000011424 {
        padding: 24px 24px 16px 24px;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000114072 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .check7 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
        cursor: pointer;
    }
    .yes-i-agree-to-share-full-stock-data-with-the-selected-suppliers {
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .yes-i-agree-to-share-full-stock-data-with-the-selected-suppliers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .yes-i-agree-to-share-full-stock-data-with-the-selected-suppliers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .yes-i-agree-to-share-full-stock-data-with-the-selected-suppliers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
    }
    .check8 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span5 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span6 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span7 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span8 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .check9 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span5 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span6 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span7 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span8 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-10000114093 {
        padding: 0px 0px 0px 67px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .check10 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .the-brand-has-at-least-15-active-b-oimages {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .the-brand-has-at-least-15-active-b-oimages-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .the-brand-has-at-least-15-active-b-oimages-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .the-brand-has-at-least-15-active-b-oimages-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .check11 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .b-oimages-have-an-average-of-3-tagged-items-span4 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .b-oimages-have-an-average-of-3-tagged-items-span5 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .b-oimages-have-an-average-of-3-tagged-items-span6 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .check12 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .create-5-new-b-oimages-per-month {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .create-5-new-b-oimages-per-month-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .create-5-new-b-oimages-per-month-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .create-5-new-b-oimages-per-month-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .frame-1000011423 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .check13 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .the-brand-achieves-a-minimum-conversion-rate-of-3-from-active-b-oimages-impressions {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .info-circle2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-10000114182 {
        flex-shrink: 0;
        position: relative;

        //override of above (lets remove the above that are overrided)
        display: flex;
        width: 270px;
        //height: 49px;
        padding-top: 20px;
        flex-direction: column;
        //justify-content: center;
        align-items: center;
        gap: 16px;
    }
    .checkbox {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        cursor: pointer;
    }
    .rectangle-12 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--text-and-icons-gray-200, #7c868b);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .check14 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
        cursor: pointer;
    }
    .i-agree-with-the-terms-conditions {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "-", sans-serif);
        font-size: var(--subtitle-1-font-size, 19px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .i-agree-with-the-terms-conditions-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .i-agree-with-the-terms-conditions-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        text-decoration: underline;
    }
    .frame-1000011399 {
        display: flex;
        justify-content: flex-start;
        align-self: stretch;
        position: relative;

        //remove duplicated
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        flex: 1 0 0;
    }
    .dropdown-selector {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 100%;
    }
    .frame-1000011449_2 {
        display: flex;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        width: 100%;
    }
`;

const DialogLayoutStyled = styled.div`
    .frame-258,
    .frame-258 * {
        box-sizing: border-box;
    }
    .frame-258 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-bottom: 32px;
    }
    .frame-285 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-286 {
        padding: 0px 32px 0px 32px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .declining-invitation {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 18px;
        font-weight: 700;
        position: relative;
        flex: 1;
    }
    .please-confirm-you-want-to-decline-the-product-invitation {
        color: var(--text-icons-gray-100, #d1d1d1);

        /* Subtitle 2 */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
    }
    .do-you-mind-sharing-the-reason {
        color: #ffffff;
        text-align: left;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011146 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 8px;
        height: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .check2 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .check3 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .check4 {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .simple {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 76px;
        position: relative;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 4px;
        padding: 10px 12px 10px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        border-style: none;
        //noresize?
        resize: none;
        outline: none;
    }
    .frame-48.disabled {
        opacity: 0.8;
        cursor: not-allowed;
    }

    .please-specify {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Italic", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        font-style: var(--subtitle-2-font-style, italic);
        position: relative;
        flex: 1;
    }
    .frame-1000011221 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        white-space: nowrap;
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-reorders-suggestions-to-suppliers-on-fast-movers-span4 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }

    .frame-1000011222 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .x-close2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-10000112172 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers {
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        white-space: nowrap;
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span2 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
    .auto-b-oimages-generation-on-suppliers-for-slow-movers-span4 {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
    }
`;
// #endregion

export default function StoreStockSharing({
    setShowTAC,
    limitedStock,
    setLimitedStock,
    fullStock,
    setFullStock,
    brandIsInvalid,
    stockSharingSelected,
    stockSharingToLabelBrands,
    setStockSharingSelected,
    setStockSharingToLabelBrands,
    retailBrandConnectedBrands,
    getConnectedRetailBrands,
    retailBrandID
}) {
    // #region STATES
    const [showNotSharingPopup, setShowNotSharingPopup] = useState({
        declinePopup: false,
        understandAblePopup: false
    });
    const [showSharingConfigurationPopup, setShowSharingConfigurationPopup] = useState(false);

    const [declineRetailBrand, setDeclineRetailBrand] = useState("");
    const [reasonObj, setReasonObj] = useState({
        reason1: false,
        reason2: false,
        reason3: false,
        reason4: false,
        otherReasonText: ""
    });
    const [showStockPopup, setShowStockPopup] = useState({
        smartDataPopup: false,
        extraDataPopup: false
    });

    const [agreesStockSharing, setAgreesStockSharing] = useState(false);
    // #endregion

    // #region POPUPS VARS
    const featureCards = [
        {
            imageSrc: OptimizedProduction,
            title: "Optimized Production & Reduced Overstock:",
            description:
                "By sharing real-time stock data, Label Brands can align their production closely with actual consumer demand. This reduces the risk of overproduction and the accumulation of unsold inventory—a primary source of textile waste."
        },
        {
            imageSrc: SupplyChain,
            title: "Enhanced Supply Chain Efficiency:",
            description:
                "With transparent inventory data, Label Brands can adjust production volumes and optimize stock levels dynamically. This data-driven decision-making enables lean operations and reduces the environmental footprint of excess manufacturing and storage."
        },
        {
            imageSrc: ProactiveReordering,
            title: "Proactive Reordering & Just-in-Time Inventory:",
            description:
                "The automated reorder suggestions ensure that fast-moving items are replenished exactly when needed, while targeted promotional efforts for moderate and slow movers help clear excess stock promptly. This just-in-time approach minimizes the need for overstocking and cuts waste."
        },
        {
            imageSrc: WasteDirective,
            title: "Improved Compliance with EU Waste Directives:",
            description:
                "By reducing unsold stock and efficiently managing inventory, the system supports the EU Waste Framework Directive on textiles. Optimized production and inventory turnover not only lead to better resource use but also help achieve sustainability targets set by the EU."
        },
        {
            imageSrc: Sustainability,
            title: "Sustainability Performance Monitoring:",
            description:
                "The BOtag dashboard provides both Retail and Label Brands with detailed metrics on inventory turnover and waste reduction. This visibility allows continuous refinement of supply chain practices, ensuring that sustainable operations translate into both environmental and financial benefits."
        },
        {
            imageSrc: Data,
            title: "Controlled and Conditional Data Sharing:",
            description:
                "Retail Brands retain full control over their sensitive inventory data. Under Tier 1, they share real-time stock and pricing data only for items featured in active BOimages, protecting the rest of their inventory. Under Tier 2, full data sharing (covering all items) is enabled only when the Retail Brand explicitly agrees to share comprehensive information and the corresponding Label Brand meets the digital engagement criteria."
        },
        {
            imageSrc: EnhancedInventory,
            title: "Enhanced Inventory Optimization:",
            description:
                "This controlled sharing mechanism drives automated, data-driven reorder suggestions for fast-moving items and triggers targeted support via digital campaigns (e.g., using BOimages) for moderate and slow movers. As a result, retailers can better manage their stock levels, minimize overstock or stockouts, and improve overall efficiency."
        },
        {
            imageSrc: DirectSale,
            title: "Enhanced Inventory Optimization:",
            description:
                "This controlled sharing mechanism drives automated, data-driven reorder suggestions for fast-moving items and triggers targeted support via digital campaigns (e.g., using BOimages) for moderate and slow movers. As a result, retailers can better manage their stock levels, minimize overstock or stockouts, and improve overall efficiency."
        }
    ];

    const extraCards = [
        {
            imageSrc: ExBoImage,
            title: "BOimages Impressions",
            description:
                "This refers to the number of times consumers view the BOimages that a Label Brand publishes. For a reliable conversion metric, we set a minimum threshold of 500 impressions per month from BOimages containing products your stores have in stock."
        },
        {
            imageSrc: ExConfirmSale,
            title: "Confirmed Sales:",
            description:
                "These are the actual transactions that occur as a result of consumers interacting with those BOimages. When a consumer sees a BOimage and clicks on a pin, eventually, if a sale is completed from your store, that counts as a confirmed sale."
        },
        {
            imageSrc: ExThreshold,
            title: "Threshold Requirement:",
            description:
                "By setting a minimum threshold of 500 impressions per BOimage containing products you have in your store per month, the metric ensures we’re evaluating conversion performance only when there is sufficient consumer exposure."
        },

        {
            imageSrc: ExConversion,
            title: "Conversion Rate Calculation:",
            description:
                "The conversion rate is the percentage of impressions that result in a confirmed sale. For example, if a BOimage gets 500 impressions in a month and 15 of those impressions lead to a confirmed sale from your store, the conversion rate would be:"
        },
        {
            imageSrc: ExPurpose,
            title: "Purpose of the Condition:",
            description:
                "Requiring a minimum conversion rate of 3% ensures that Brands are not just publishing BOimages but that these images are effectively driving sales. This performance condition incentivizes Brands to optimize their content and promotions so that their digital presence translates into tangible retail success. Only when this conversion metric is met would the full data sharing be activated, ensuring that your full stock data is shared only with partners who are actively converting consumer interest into sales."
        },
        {
            title: "what this is about",
            description:
                "In essence, this requirement is a quality control measure: it confirms that the digital marketing efforts (BOimages) are effective enough at driving sales for Retail Brands commit to sharing their full, sensitive stock data."
        }
    ];
    // #endregion

    // #region METHODS
    const callUpdateAllStoresRequest = async () => {
        const postData = {
            retailBrandID: retailBrandID,
            stockSharing: limitedStock ? "BOimages" : "All",
            stockSharingLabelBrandIDs: stockSharingToLabelBrands.map(brand => brand?.value)
        };
        const res = await Library.makePostRequest("updateRetailBrandStockSharing", postData);
        //const data = res?.data?.data;
        const status = res?.data?.status;
        if (status === 200) {
            Library.showToastMessage({
                type: "success",
                title: "Sharing stock decision for all new stores!",
                description:
                    "This decision will become standard for all your new stores once you finish enrolling this store and hit SAVE to save it."
            });
        }
    };
    // #endregion

    // #region RENDER
    return (
        <StyledPage>
            <FullScreenOverlay show={showNotSharingPopup.declinePopup}>
                <DialogBoxComponent
                    title="Not sharing stock data with suppliers?"
                    useAlternativeLayout={
                        <DeclineReasonLayout
                            reasonObj={reasonObj}
                            setReasonObj={setReasonObj}
                            declineRetailBrand={declineRetailBrand}
                        />
                    }
                    confirmText="I WILL RECONSIDER"
                    cancelText="CONFIRM"
                    heading="DECLINING..."
                    headingColor="var(--text-icons-red-500)"
                    confirmState
                    onClickYes={() => {
                        setShowNotSharingPopup({
                            declinePopup: false,
                            understandAblePopup: false
                        });
                        setStockSharingSelected(prev => ({
                            ...prev,
                            shareStockDisabled: false
                        }));
                        Library.showToastMessage({
                            type: "success",
                            title: "Giving it a second thought is always good!",
                            description: "If something doesn’t feel right let us know, we will fix it for you."
                        });
                    }}
                    onClickNo={() => {
                        setShowNotSharingPopup({
                            declinePopup: false,
                            understandAblePopup: true
                        });
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showNotSharingPopup.understandAblePopup}>
                <DialogBoxComponent
                    title="Not sharing stock!"
                    useAlternativeLayout={
                        <div className="last-container">
                            <div>
                                Is this a decision for this store only, or for all your other stores you enroll from now
                                on?
                            </div>
                            <div className="simple">
                                <div className="input-selector-inverted">
                                    <div className="search">
                                        <div className="frame-48">
                                            <div className="you-can-always-change-this-decision-on-a-store-by-store-level-in-the-store-lists-views-store-menu-in-the-navigation-bar-on-the-left-then-stores-button-in-the-control-bar-on-top-and-then-view-button-also-in-the-control-bar-on-the-right">
                                                You can always change this decision on a store-by-store level in the
                                                store lists views.
                                                <br />
                                                → STORE menu (in the navigation bar on the left), then
                                                <br />
                                                → STORES button (in the control bar on top) and then
                                                <br />→ VIEW button (also in the control bar on the right).
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    confirmText="THIS STORE ONLY"
                    cancelText="ALL STORES"
                    heading="UNDERSTANDABLE..."
                    confirmState
                    headingColor="#00BB00"
                    onClickYes={() => {
                        setShowNotSharingPopup({
                            understandAblePopup: false,
                            declinePopup: false
                        });

                        Library.showToastMessage({
                            type: "success",
                            title: "Not sharing stock decision for this store!",
                            description:
                                "This decision will only affect this store once you finish enrolling the store and hit SAVE to save it."
                        });
                    }}
                    onClickNo={() => {
                        setShowNotSharingPopup({
                            understandAblePopup: false,
                            declinePopup: false
                        });
                        Library.showToastMessage({
                            type: "success",
                            title: "Not sharing stock decision for all stores!",
                            description:
                                "This decision will become standard for all your new stores once you finish enrolling this store and hit SAVE to save it."
                        });
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showSharingConfigurationPopup}>
                <DialogBoxComponent
                    title="Sharing stock with suppliers!"
                    useAlternativeLayout={
                        <div className="last-container">
                            <div>
                                This store will share stock data in real time with the selected suppliers, provided they
                                comply with the required conditions, and the POS in this store is connected to BOtag
                                (next step). <br />
                                --
                                <br />
                                Would you like to make this stock sharing decision standard for all new stores?
                            </div>
                            <div className="simple">
                                <div className="input-selector-inverted">
                                    <div className="search">
                                        <div className="frame-48">
                                            <div className="you-can-always-change-this-decision-on-a-store-by-store-level-in-the-store-lists-views-store-menu-in-the-navigation-bar-on-the-left-then-stores-button-in-the-control-bar-on-top-and-then-view-button-also-in-the-control-bar-on-the-right">
                                                You can always change this decision on a store-by-store level in the
                                                store lists views.
                                                <br />
                                                → STORE menu (in the navigation bar on the left), then
                                                <br />
                                                → STORES button (in the control bar on top) and then
                                                <br />→ VIEW button (also in the control bar on the right).
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    confirmText="THIS STORE ONLY"
                    cancelText="ALL STORES"
                    heading="JUST CHECKING..."
                    confirmState
                    headingColor="#00BB00"
                    onClickYes={() => {
                        setShowSharingConfigurationPopup(false);

                        Library.showToastMessage({
                            type: "success",
                            title: "Sharing stock decision for this store!",
                            description:
                                "This decision will only affect this store once you finish enrolling the store and hit SAVE to save it."
                        });
                    }}
                    onClickNo={() => {
                        setShowSharingConfigurationPopup(false);

                        callUpdateAllStoresRequest();
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showStockPopup.smartDataPopup || showStockPopup.extraDataPopup}>
                <StandardStockPopup
                    featureCards={featureCards}
                    extraCards={extraCards}
                    setShowStockPopup={setShowStockPopup}
                    showStockPopup={showStockPopup}
                />
            </FullScreenOverlay>

            <CardComponentContainer title="STOCK SHARING" anchorUrl="#stock-sharing">
                <StockSharingStyles>
                    <div className="top-title frame-1000011410" style={{ marginTop: "24px", marginBottom: "16px" }}>
                        <div className="do-you-want-to-share-stock-with-your-suppliers">
                            Do you want to share stock WITH YOUR SUPPLIERS?
                        </div>
                    </div>

                    <div className="frame-1000011201">
                        <WhyShareStockWithSuppliers
                            setShowStockPopup={setShowStockPopup}
                            stockSharingSelected={stockSharingSelected}
                            setStockSharingSelected={setStockSharingSelected}
                            setShowNotSharingPopup={setShowNotSharingPopup}
                            setLimitedStock={setLimitedStock}
                            setFullStock={setFullStock}
                        />

                        <AgreeShareStockCards
                            limitedStock={limitedStock}
                            setLimitedStock={setLimitedStock}
                            stockSharingSelected={stockSharingSelected}
                            fullStock={fullStock}
                            setFullStock={setFullStock}
                            setShowStockPopup={setShowStockPopup}
                            stockSharingToLabelBrands={stockSharingToLabelBrands}
                            setStockSharingSelected={setStockSharingSelected}
                            setShowTAC={setShowTAC}
                            getConnectedRetailBrands={getConnectedRetailBrands}
                            retailBrandConnectedBrands={retailBrandConnectedBrands}
                            brandIsInvalid={brandIsInvalid}
                            setStockSharingToLabelBrands={setStockSharingToLabelBrands}
                            setShowSharingConfigurationPopup={setShowSharingConfigurationPopup}
                        />
                    </div>
                </StockSharingStyles>

                <StockSharingStyles style={{ marginTop: "24px" }}>
                    <div className="frame-1000011449_2">
                        <div className="frame-1000011399">
                            <div className="dropdown-selector">
                                <FormField
                                    type="dropdown"
                                    title={
                                        <div className="flex flex-row gap-8px">
                                            <span>Share stock information with: </span>
                                            <LoadingSpinner loading={stockSharingSelected.loading} />
                                        </div>
                                    }
                                    tooltip="Select one or more label brands"
                                    requiredType={
                                        (!stockSharingSelected.agreeTerms && !limitedStock && !fullStock) ||
                                        stockSharingSelected?.shareStock ||
                                        !stockSharingSelected?.shareDropdownEnabled
                                            ? "locked"
                                            : "mandatory"
                                    }
                                    dropdownData={retailBrandConnectedBrands || []}
                                    isInvalid={brandIsInvalid}
                                    onDropdownChange={itemsSelected => {
                                        setStockSharingToLabelBrands(itemsSelected);

                                        if (itemsSelected?.length > 0 && itemsSelected[0]?.value !== "allLabelBrands") {
                                            setShowSharingConfigurationPopup(true);
                                        }
                                    }}
                                    isDropdownMultiselect={true}
                                    isDropdownSearchable={true}
                                    multidropdownOptions={{
                                        useDoneButton: true,
                                        useSelectAll:
                                            retailBrandConnectedBrands?.[0]?.value === "allLabelBrands" ? false : true,
                                        selectAllText: "Select all label brands",
                                        placeholderTextFunction: defaultPlaceholderTextFunction2,
                                        allItems: retailBrandConnectedBrands,
                                        labelAllSelected: "All label brands",
                                        labelNoneSelected: "Select one or more label brands"
                                    }}
                                    assistiveText=" "
                                />
                            </div>
                        </div>

                        <div className="frame-10000114182">
                            <div className="frame-1000011405">
                                <div className="frame-10000112232">
                                    <CheckboxVector
                                        className={`checkbox ${
                                            (stockSharingSelected.shareStockDisabled ||
                                                stockSharingSelected.agreeTerms) &&
                                            "disabled"
                                        }`}
                                        onCheckboxClick={() => {
                                            if (stockSharingSelected.agreeTerms) return;

                                            if (retailBrandConnectedBrands?.length === 0) getConnectedRetailBrands();

                                            setStockSharingSelected(prev => {
                                                return { ...prev, agreeTerms: true };
                                            });

                                            /*let agreeTerms = false;
                                            setStockSharingSelected(prev => {
                                                agreeTerms = !prev.agreeTerms;
                                                return { ...prev, agreeTerms: agreeTerms };
                                            });

                                            if (agreeTerms) */
                                        }}
                                        isChecked={stockSharingSelected.agreeTerms}
                                    />
                                    <div className="frame-1000011217">
                                        <div
                                            className="i-agree-with-the-terms-conditions"
                                            style={{ display: "flex", flexDirection: "row" }}>
                                            <div
                                                className={`i-agree-with-the-terms-conditions-span ${
                                                    stockSharingSelected.shareStockDisabled && "disabled"
                                                }`}>
                                                I agree with the&nbsp;
                                            </div>
                                            <div
                                                className={`i-agree-with-the-terms-conditions-span2 cursor-pointer ${
                                                    stockSharingSelected.shareStockDisabled && "disabled"
                                                }`}
                                                onClick={() => setShowTAC(true)}>
                                                Terms &amp; Conditions
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </StockSharingStyles>
            </CardComponentContainer>
        </StyledPage>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const SelectSupplierStock = ({ stock, onClick, limited, disabled, setShowStockPopup }) => {
    return (
        <div
            className={`tier-3 ${disabled && "disabled"}`}
            style={{
                background:
                    stock &&
                    "linear-gradient(21.32deg, rgba(255, 153, 0, 0) 60%, rgba(255, 153, 0, 0.2) 100%),linear-gradient(to left, #141922, #141922)"
            }}>
            <div className="frame-1000011219">
                <div className="frame-10000114062">
                    <div className="frame-1000011438">
                        <div className={`radiobuttons ${disabled && "disabled"}`}>
                            {stock ? (
                                <img
                                    className="rectangle-1"
                                    src={radioButton}
                                    alt=""
                                    //onClick={() => setStock(!stock)}
                                    onClick={onClick}
                                />
                            ) : (
                                <div className="rectangle-1" onClick={onClick}></div>
                            )}
                        </div>
                        <div className="frame-1000011217">
                            <div className="frame-1000011407">
                                <div className="yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers">
                                    <span>
                                        <span
                                            className={`yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span ${
                                                disabled && "disabled"
                                            }`}>
                                            YES - I agree to share
                                        </span>
                                        <span
                                            className={`yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span2 ${
                                                disabled && "disabled"
                                            }`}>
                                            {limited ? " limited" : " full"} stock data{" "}
                                        </span>
                                        <span
                                            className={`yes-i-agree-to-share-limited-stock-data-with-the-selected-suppliers-span3 ${
                                                disabled && "disabled"
                                            }`}>
                                            with the selected suppliers.
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011439">
                        <div className="frame-1000011409">
                            <div className="frame-1000011221">
                                {limited ? (
                                    <img className="x-close2" alt="" src={Close} />
                                ) : (
                                    <img className="x-close2" alt="" src={check} />
                                )}
                                <div className="frame-1000011217">
                                    <div className="auto-reorders-suggestions-to-suppliers-on-fast-movers">
                                        <span>
                                            <span
                                                className={`auto-reorders-suggestions-to-suppliers-on-fast-movers-span ${
                                                    disabled && "disabled"
                                                }`}>
                                                Auto
                                            </span>
                                            <span
                                                className={`auto-reorders-suggestions-to-suppliers-on-fast-movers-span2 ${
                                                    disabled && "disabled"
                                                }`}>
                                                {" "}
                                                reorders{" "}
                                            </span>
                                            <span
                                                className={`auto-reorders-suggestions-to-suppliers-on-fast-movers-span3 ${
                                                    disabled && "disabled"
                                                }`}>
                                                suggestions to suppliers on
                                            </span>
                                            <span
                                                className={`auto-reorders-suggestions-to-suppliers-on-fast-movers-span4 ${
                                                    disabled && "disabled"
                                                }`}>
                                                {" "}
                                                Fast Movers{" "}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="frame-1000011222">
                                {limited ? (
                                    <img className="x-close2" alt="" src={Close} />
                                ) : (
                                    <img className="x-close2" alt="" src={check} />
                                )}

                                <div className="frame-10000112172">
                                    <div className="auto-b-oimages-generation-on-suppliers-for-slow-movers">
                                        <span>
                                            <span
                                                className={`auto-b-oimages-generation-on-suppliers-for-slow-movers-span ${
                                                    disabled && "disabled"
                                                }`}>
                                                Auto
                                            </span>
                                            <span
                                                className={`auto-b-oimages-generation-on-suppliers-for-slow-movers-span2 ${
                                                    disabled && "disabled"
                                                }`}>
                                                {" "}
                                                BOimages{" "}
                                            </span>
                                            <span
                                                className={`auto-b-oimages-generation-on-suppliers-for-slow-movers-span3 ${
                                                    disabled && "disabled"
                                                }`}>
                                                generation on suppliers for
                                            </span>
                                            <span
                                                className={`auto-b-oimages-generation-on-suppliers-for-slow-movers-span4 ${
                                                    disabled && "disabled"
                                                }`}>
                                                {" "}
                                                Slow Movers{" "}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011418">
                            <div className="frame-1000011405">
                                <div className="frame-10000112232">
                                    <div className="frame-1000011217">
                                        <div
                                            className={`even-if-you-allow-stock-sharing-your-stock-will-only-be-shared-with-brands-complying-with-the-below-supplier-conditions ${
                                                disabled && "disabled"
                                            }`}>
                                            Even if you allow stock sharing, your stock will only be shared with brands
                                            complying with the below supplier conditions.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="frame-1000011415">
                                <div className="frame-10000112232">
                                    <div className="frame-1000011217">
                                        <div
                                            className={`each-brand-can-only-see-stock-of-their-labeled-products ${
                                                disabled && "disabled"
                                            }`}>
                                            Each brand can only see stock of their labeled products.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="frame-10000114212">
                <div className={`supplier-conditions ${disabled && "disabled"}`}>SUPPLIER CONDITIONS</div>
                <div className="line-5"></div>
            </div>
            <div className="frame-1000011226">
                <div className="frame-10000114092">
                    <div className="frame-1000011221">
                        {disabled ? (
                            <img className="check3" src={disabledCheck} alt="" />
                        ) : (
                            <img className="check3" src={check} alt="" />
                        )}

                        <div className="frame-1000011217">
                            <div className="the-brand-has-at-least-10-active-b-oimages">
                                <span>
                                    <span
                                        className={`the-brand-has-at-least-10-active-b-oimages-span ${
                                            disabled && "disabled"
                                        }`}>
                                        The Brand has at least
                                    </span>
                                    <span
                                        className={`the-brand-has-at-least-10-active-b-oimages-span2 ${
                                            disabled && "disabled"
                                        }`}>
                                        {limited ? " 10 active " : " 15 active "}
                                    </span>
                                    <span
                                        className={`the-brand-has-at-least-10-active-b-oimages-span3 ${
                                            disabled && "disabled"
                                        }`}>
                                        BOimages
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011220">
                        {disabled ? (
                            <img className="check4" src={disabledCheck} alt="" />
                        ) : (
                            <img className="check4" src={check} alt="" />
                        )}
                        <div className="frame-10000112172">
                            <div className="b-oimages-have-an-average-of-3-tagged-items">
                                <span>
                                    <span
                                        className={`b-oimages-have-an-average-of-3-tagged-items-span ${
                                            disabled && "disabled"
                                        }`}>
                                        BOimages have an average of
                                    </span>
                                    <span
                                        className={`b-oimages-have-an-average-of-3-tagged-items-span2 ${
                                            disabled && "disabled"
                                        }`}>
                                        {" "}
                                        3 tagged{" "}
                                    </span>
                                    <span
                                        className={`b-oimages-have-an-average-of-3-tagged-items-span3 ${
                                            disabled && "disabled"
                                        }`}>
                                        items
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011222">
                        {disabled ? (
                            <img className="check5" src={disabledCheck} alt="" />
                        ) : (
                            <img className="check5" src={check} alt="" />
                        )}
                        <div className="frame-10000112172">
                            <div className="create-3-new-b-oimages-per-month">
                                <span>
                                    <span className={`create-3-new-b-oimages-per-month-span ${disabled && "disabled"}`}>
                                        Publish at least
                                    </span>
                                    <span
                                        className={`create-3-new-b-oimages-per-month-span2 ${disabled && "disabled"}`}>
                                        {limited ? " 3 new " : " 5 new "}
                                    </span>
                                    <span
                                        className={`create-3-new-b-oimages-per-month-span3 ${disabled && "disabled"}`}>
                                        BOimages per month
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="frame-1000011425">
                <div className="frame-1000011422">
                    <span className={`extra-condition ${disabled && "disabled"}`}>
                        {limited ? "SUPPLIER" : ""} EXTRA CONDITION
                    </span>

                    <div className="line-5"></div>
                </div>
                <div className="frame-1000011224">
                    {disabled ? (
                        <img className="check6" src={disabledCheck} alt="" />
                    ) : (
                        <img className="check6" src={check} alt="" />
                    )}
                    <div className="frame-10000112172">
                        {limited ? (
                            <div className={`free-from-extra-conditions ${disabled && "disabled"}`}>
                                Free from extra conditions
                            </div>
                        ) : (
                            <div
                                className={`the-brand-achieves-a-minimum-conversion-rate-of-3-from-active-b-oimages-impressions ${
                                    disabled && "disabled"
                                }`}>
                                The Brand achieves a minimum conversion rate of 3% from active BOimages impressions
                            </div>
                        )}

                        <Tooltip
                            title={
                                limited ? (
                                    "Once you allow your suppliers (brands) to follow your stock, and they comply with the SUPPLIER CONDITIONS, they will be able to provide you support on the items they tag in their BOimages"
                                ) : (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <div style={{ marginBottom: 5 }}>
                                            The conversion-based metric is designed to ensure that Label Brands are
                                            actively driving consumer engagement, generating sales through BOimages to
                                            keep access to your stock data.
                                        </div>
                                        <button
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor: "#1E2631",
                                                borderRadius: "4px",
                                                height: "35px",
                                                border: "none",
                                                width: "80px"
                                            }}
                                            onClick={() =>
                                                setShowStockPopup({
                                                    extraDataPopup: true
                                                })
                                            }>
                                            See more
                                        </button>
                                    </div>
                                )
                            }
                            color="#10141b">
                            <img className="info-circle" src={info} alt="" />
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    );
};

const DeclineReasonLayout = props => {
    const { reasonObj, setReasonObj } = props;

    const otherReasonRef = React.createRef();

    useEffect(() => {
        if (reasonObj.reason4) {
            otherReasonRef.current.focus();
        }
    }, [reasonObj.reason4]);

    return (
        <DialogLayoutStyled className="DialogLayout">
            <div className="frame-258">
                <div className="frame-285">
                    <div className="frame-160">
                        <div className="please-confirm-you-want-to-decline-the-product-invitation">
                            Your suppliers wont be able to help you sell out what you bought in from them, for this
                            store, at the best margin possible.
                        </div>
                        <div style={{ fontSize: "12px", whiteSpace: "nowrap", fontWeight: 400 }}>
                            BOtag will also not be able to provide you with, for this store:
                        </div>
                        <div style={{ width: "90%" }}>
                            <div className="frame-1000011221">
                                <img className="x-close" src={Close} alt="" />
                                <div className="frame-1000011217">
                                    <div className="auto-reorders-suggestions-to-suppliers-on-fast-movers">
                                        <span>
                                            <span className="auto-reorders-suggestions-to-suppliers-on-fast-movers-span">
                                                Auto
                                            </span>
                                            <span className="auto-reorders-suggestions-to-suppliers-on-fast-movers-span2">
                                                {" "}
                                                reorders{" "}
                                            </span>
                                            <span className="auto-reorders-suggestions-to-suppliers-on-fast-movers-span3">
                                                suggestions to suppliers on
                                            </span>
                                            <span className="auto-reorders-suggestions-to-suppliers-on-fast-movers-span4">
                                                Fast Movers{" "}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="frame-1000011222">
                                <img className="x-close2" alt="" src={Close} />
                                <div className="frame-10000112172">
                                    <div className="auto-b-oimages-generation-on-suppliers-for-slow-movers">
                                        <span>
                                            <span className="auto-b-oimages-generation-on-suppliers-for-slow-movers-span">
                                                Auto
                                            </span>
                                            <span className="auto-b-oimages-generation-on-suppliers-for-slow-movers-span2">
                                                {" "}
                                                BOimages{" "}
                                            </span>
                                            <span className="auto-b-oimages-generation-on-suppliers-for-slow-movers-span3">
                                                generation on suppliers for
                                            </span>
                                            <span className="auto-b-oimages-generation-on-suppliers-for-slow-movers-span4">
                                                Slow Movers{" "}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="do-you-mind-sharing-the-reason">
                            Do you mind helping us understand your decision?
                        </div>
                        <div className="frame-1000011146">
                            <div className="checkbox-label">
                                <CheckboxVector
                                    className="checkbox"
                                    isChecked={reasonObj.reason1}
                                    onCheckboxClick={() => {
                                        setReasonObj({
                                            reason1: !reasonObj.reason1,
                                            reason2: false,
                                            reason3: false,
                                            reason4: false,
                                            otherReasonText: ""
                                        });
                                    }}
                                />
                                <div className="text" style={{ height: "16px" }}>
                                    I don’t know this retailer
                                </div>
                            </div>
                            <div className="checkbox-label">
                                <CheckboxVector
                                    className="checkbox"
                                    isChecked={reasonObj.reason2}
                                    onCheckboxClick={() => {
                                        setReasonObj({
                                            reason1: false,
                                            reason2: !reasonObj.reason2,
                                            reason3: false,
                                            reason4: false,
                                            otherReasonText: ""
                                        });
                                    }}
                                />{" "}
                                <div className="text" style={{ height: "16px" }}>
                                    I don’t want to work with this retailer
                                </div>
                            </div>
                            <div className="checkbox-label">
                                <CheckboxVector
                                    className="checkbox"
                                    isChecked={reasonObj.reason3}
                                    onCheckboxClick={() => {
                                        setReasonObj({
                                            reason1: false,
                                            reason2: false,
                                            reason3: !reasonObj.reason3,
                                            reason4: false,
                                            otherReasonText: ""
                                        });
                                    }}
                                />{" "}
                                <div className="text" style={{ height: "16px" }}>
                                    I’ll stop working with this retailer
                                </div>
                            </div>
                            <div className="checkbox-label">
                                <CheckboxVector
                                    className="checkbox"
                                    isChecked={reasonObj.reason4}
                                    onCheckboxClick={() => {
                                        setReasonObj({
                                            reason1: false,
                                            reason2: false,
                                            reason3: false,
                                            reason4: !reasonObj.reason4,
                                            otherReasonText: ""
                                        });
                                    }}
                                />{" "}
                                <div className="text" style={{ height: "16px" }}>
                                    Other reasons:
                                </div>
                            </div>
                            <div className="simple">
                                <div className="input-selector-inverted">
                                    <div className="search">
                                        <textarea
                                            ref={otherReasonRef}
                                            className={`frame-48 ${reasonObj.reason4 ? "" : "disabled"}`}
                                            placeholder="Please specify"
                                            value={reasonObj.otherReasonText}
                                            disabled={!reasonObj.reason4}
                                            onChange={e => {
                                                setReasonObj({ ...reasonObj, otherReasonText: e.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>Please confirm you want to decline sharing this store stock.</div>
                        </div>
                    </div>
                </div>
            </div>
        </DialogLayoutStyled>
    );
};

const WhyShareStockWithSuppliers = ({
    setShowStockPopup,
    stockSharingSelected,
    setStockSharingSelected,
    setShowNotSharingPopup,
    setLimitedStock,
    setFullStock
}) => {
    return (
        <div className="why-share-card frame-1000011421">
            <div className="frame-1000011450">
                <div className="tier-0">
                    <div className="line-3"></div>
                    <div className="frame-1000011223">
                        <div className="frame-1000011440">
                            <div className="why-should-i-share-stock-with-my-suppliers">
                                Why should I share stock WITH MY SUPPLIERS?
                            </div>
                            <div className="frame-1000011411">
                                <div className="frame-1000011432">
                                    <div className="frame-10000114322">
                                        <div className="frame-1000011434">
                                            <img className="group-1000011038" src={DirectSale1} alt="" />
                                        </div>
                                        <div className="frame-1000011437">
                                            <div className="text">Direct Sales Support:</div>
                                            <div className="text2">
                                                By sharing, you’re activating a dynamic digital partnership which
                                                enables your suppliers to monitor their products performance in real
                                                time and quickly rally support.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="frame-1000011429">
                                        <div className="frame-1000011434">
                                            <img className="group-1000011037" src={BudgetOptimization} alt="" />
                                        </div>
                                        <div className="frame-1000011436">
                                            <div className="text">Enhanced Inventory and budget Optimization:</div>
                                            <div className="text2">
                                                This controlled sharing enables automated reorder suggestions for fast
                                                movers and targeted digital support for slower items, helping optimizing
                                                your stock levels and boost efficiency.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="frame-1000011428">
                                        <div className="frame-1000011434">
                                            <div className="frame-1000011433">
                                                <img className="group-1000011039" src={DataSharing} alt="" />
                                            </div>
                                        </div>
                                        <div className="frame-1000011435">
                                            <div className="text">Controlled and Conditional Data Sharing:</div>
                                            <div className="text2">
                                                You fully control your inventory data, sharing only active BOimage item
                                                details or allowing full access only with consent and qualified supplier
                                                engagement.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011427">
                            <div
                                className="btn-large-inverted"
                                onClick={prev =>
                                    setShowStockPopup({
                                        ...prev,
                                        smartDataPopup: true,
                                        extraDataPopup: false
                                    })
                                }>
                                <div className="button" style={{ color: "#D1D1D1" }}>
                                    STILL NOT SURE, CLICK HERE
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011406">
                            <div className="radiobuttons">
                                {stockSharingSelected.shareStockDisabled ? (
                                    <img
                                        className="rectangle-1"
                                        src={radioButton}
                                        alt=""
                                        onClick={() => {
                                            setStockSharingSelected(prev => ({
                                                ...prev,
                                                shareStockDisabled: !stockSharingSelected.shareStockDisabled
                                            }));
                                        }}
                                    />
                                ) : (
                                    <div
                                        className="rectangle-1"
                                        onClick={() => {
                                            setStockSharingSelected(prev => ({
                                                ...prev,
                                                shareStockDisabled: !stockSharingSelected.shareStockDisabled,
                                                shareDropdownEnabled: false,
                                                agreeTerms: false
                                            }));
                                            setShowNotSharingPopup({
                                                declinePopup: true,
                                                understandAblePopup: false
                                            });
                                            setLimitedStock(false);
                                            setFullStock(false);
                                        }}></div>
                                )}
                            </div>

                            <div className="frame-1000011217">
                                <div className="frame-1000011407">
                                    <div className="i-don-t-want-to-share-my-stock-data-with-any-of-my-suppliers">
                                        I don’t want to share my stock data with any of my suppliers
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AgreeShareStockCards = ({
    limitedStock,
    setLimitedStock,
    stockSharingSelected,
    fullStock,
    setFullStock,
    setShowStockPopup,
    stockSharingToLabelBrands,
    setStockSharingSelected,
    setShowTAC,
    getConnectedRetailBrands,
    retailBrandConnectedBrands,
    brandIsInvalid,
    setStockSharingToLabelBrands,
    setShowSharingConfigurationPopup
}) => {
    return (
        <div className="yes-cards frame-1000011251">
            <div className="frame-1000011449">
                <div className="frame-1000011414">
                    {/* CARD: YES - I agree to share limited stock data with the selected suppliers. */}
                    <SelectSupplierStock
                        stock={limitedStock}
                        setStock={setLimitedStock}
                        limited={true}
                        disabled={stockSharingSelected.shareStockDisabled}
                        onClick={() => {
                            setLimitedStock(prev => !prev);
                            setFullStock(false);

                            if (retailBrandConnectedBrands?.length === 0) getConnectedRetailBrands();
                        }}
                    />

                    {/* YES - I agree to share full stock data with the selected suppliers. */}
                    <SelectSupplierStock
                        stock={fullStock}
                        setStock={setFullStock}
                        limited={false}
                        disabled={stockSharingSelected.shareStockDisabled}
                        setShowStockPopup={setShowStockPopup}
                        onClick={() => {
                            setFullStock(prev => !prev);
                            setLimitedStock(false);

                            if (retailBrandConnectedBrands?.length === 0) getConnectedRetailBrands();
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

const LoadingSpinner = props => {
    return (
        <div className={`loaderclass ${props?.loading === true ? "" : "hidden"} `}>
            <i className="fa fa-spinner fa-spin" style={{ color: "var(--App-Accent-Outline)" }} />
        </div>
    );
};

const defaultPlaceholderTextFunction2 = (selectedItems, allItems, labelAllSelected, labelNoneSelected) => {
    if (!selectedItems?.length) return labelNoneSelected;

    const nonLockedItems = allItems?.filter(item => !item?.locked);
    const areAllSelected = selectedItems?.length === nonLockedItems?.length;

    //if (areAllSelected) return `${labelAllSelected} (${nonLockedItems?.length})`;
    if (areAllSelected) return `${labelAllSelected}`;

    if (selectedItems?.length === 1) return selectedItems[0]?.name;

    return `${selectedItems?.length} selected`;
};
// #endregion
